import React from 'react'
import { render } from 'react-dom'
import EditCard from './step-editor'

/*
  参考ModalManager封装的StepEditor类
  调用StepEditor.openStepEditor可打开步骤录制弹窗（弹窗唯一不可重复打开）
  挂载到window对象,可直接通过window.openStepEditor调用
*/

class StepEditor {
  static openStepEditor() {
    const doc = window.document
    if (doc.getElementById('stepEditor')) {
      return
    }
    const node = doc.createElement('div')
    node.id = 'stepEditor' // 保证打开唯一的窗口
    doc.body.appendChild(node)
    render((
      <div>
        <EditCard />
      </div>
    ), node)
  }
}

window.openStepEditor = StepEditor.openStepEditor // 挂载到window对象

export default StepEditor
